import React from "react";
import { BrandsWithObjectTypeUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const BrandsDropdown = ({
  resources,
  brand,
  objectType,
  brands = [],
  filteredByObjectType = false,
  onBrandChange,
  onRequestStart,
  onRequestEnd,
  containerClass,
  id = "brand-dropdown",
  disabled = false,
  required = false,
  defaultValue = null,
  noPlaceholder = false
}) => {

  const hasBrands = brands && brands.length > 0;

  const getDataSource = () => {
    if (filteredByObjectType && hasBrands) {
      return { values: brands };
    } else {
      return { sourceUrl: BrandsWithObjectTypeUrl(objectType) };
    }
  };

  const getMapping = () => {
    return (a) => ({ key: a.id, name: a.description });
  };

  const dataSource = getDataSource();

  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["Brand"]}
      value={brand}
      placeholder={noPlaceholder ? null : defaultValue ?? resources["All"]}
      handleChange={onBrandChange}
      inputName="brand"
      addMarginBottom={false}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      {...dataSource}
      map={getMapping()}
      sort={(a, b) => (a.description > b.description) ? 1 : -1}
    />
  );
};

export default BrandsDropdown;
